import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from "rxjs/Observable";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';

import * as globalConst from './../../../../constants';

@Injectable()
export class HolidaysInsertService {

	private apiUrl = globalConst.baseAPI;

	constructor(private http: Http) { }

  getHolidays(token) {
		

		
		
		
		
		
		

		return this.http
		.get(this.apiUrl + "holiday/v1/getholiday", JSON.parse(localStorage.getItem('yara.connectionHeader')))
		.map((res: Response) => res.json()).catch(e => {
			if (e.status === 401) {
				return Observable.throw('Unauthorized');
			}
		});
	}

	insertHoliday(token, data: any) {
		

		
		
		
		
		
		

		return this.http
		.post(this.apiUrl + "holiday/v1/insertholiday", data, JSON.parse(localStorage.getItem('yara.connectionHeader')))
		.map((res: Response) => res.json()).catch(e => {
			if (e.status === 401) {
			return Observable.throw('Unauthorized');
			}
		});
	}

	removeHoliday(token, id) {
		

		
		
		
		
		
		

		return this.http
		.delete(this.apiUrl + "holiday/v1/inactiveholiday/" + id, JSON.parse(localStorage.getItem('yara.connectionHeader')))
		.map((res: Response) => res.json()).catch(e => {
			if (e.status === 401) {
			return Observable.throw('Unauthorized');
			}
		});
	}

}



// WEBPACK FOOTER //
// ./src/app/holidays/service/holidays-insert/holidays-insert.service.ts